export * from './gif-player.component';
export * from './gif-player.module';
